import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: 620,
    height: 378,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 44,
    paddingBottom: 29,
    [theme.breakpoints.down('lg')]: {
      width: 580,
    },
    [theme.breakpoints.down('md')]: {
      width: 236,
      height: 274,
      paddingTop: 15,
      paddingBottom: 0,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        width: 580,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: 236,
        height: 274,
        paddingTop: 15,
        paddingBottom: 0,
      }),
    },
  },
  message: {
    textAlign: 'center',
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(3.125),
    width: 365,
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3.75),
      marginTop: theme.spacing(3.125),
      width: 208,
      lineHeight: '20px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3.75),
        marginTop: theme.spacing(3.125),
        width: 208,
        lineHeight: '20px',
      }),
    },
  },
  button: {
    width: 140,
    [theme.breakpoints.down('md')]: {
      width: 236,
      height: 44,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: 236,
        height: 44,
      }),
    },
  },
  icon: {
    alignItems: 'center',
    background: '#F4F4F4',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    height: 120,
    width: 120,
    '& svg': {
      cursor: 'initial',
    },
  },
}));
